import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-internal-server-error',
  templateUrl: './internal-server-error.component.html',
  styleUrls: ['./internal-server-error.component.css']
})
export class InternalServerErrorComponent implements OnInit {

   @Output() cerrar = new EventEmitter<Boolean>();
   @Input() errorData = undefined;

  constructor() { }

  ngOnInit(): void {
    console.log(this.errorData);
  }

  close(){
    this.cerrar.emit(false);
    window.location.reload();
  }

}
